import {
  EMPLOYEE_SHIFT_FETCHING,
  EMPLOYEE_SHIFT_FAILED,
  EMPLOYEE_SHIFT_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEE_SHIFT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case EMPLOYEE_SHIFT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case EMPLOYEE_SHIFT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
